module.exports = __webpack_public_path__ + "static/media/quiz_list.2371583c.svg";